// Account menu - desktop popover on the header "Contul meu" button.
// Opens on hover (pointer devices) and on click/keyboard via the chevron
// toggle; closes on mouseleave, Escape, outside-click and blur. The account
// button itself keeps its href (a plain click still navigates to /cont/).
import { qsa, on } from '../lib/dom.js';

const HOVER_OPEN_MS = 80;
const HOVER_CLOSE_MS = 180;

function setOpen(menu, toggle, open) {
  menu.classList.toggle('is-open', open);
  if (toggle) toggle.setAttribute('aria-expanded', String(open));
}

export function initAccountMenu() {
  const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  qsa('[data-component="account-menu"]').forEach((menu) => {
    const toggle = menu.querySelector('.ap-account-menu__toggle');
    if (!toggle) return;

    let openTimer = null;
    let closeTimer = null;
    let openedAt = 0; // when hover/focus last opened the menu (see click handler)
    const clearTimers = () => {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    };
    const open = () => { openedAt = Date.now(); setOpen(menu, toggle, true); };

    // Chevron toggle: click / Enter / Space. On pointer devices hover (or the
    // focus the click gives the button) has usually already opened the menu by
    // the time the click lands, so a click right after that open KEEPS it open
    // rather than immediately toggling it shut; otherwise it toggles (keyboard
    // Enter on an already-focused button, or a deliberate second click).
    on(toggle, 'click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      clearTimers();
      const isOpen = menu.classList.contains('is-open');
      const justOpened = isOpen && (Date.now() - openedAt) < 400;
      setOpen(menu, toggle, justOpened ? true : !isOpen);
    });

    // Hover (desktop only) - open on enter, close shortly after leave.
    if (supportsHover) {
      on(menu, 'mouseenter', () => {
        clearTimers();
        openTimer = setTimeout(open, HOVER_OPEN_MS);
      });
      on(menu, 'mouseleave', () => {
        clearTimers();
        closeTimer = setTimeout(() => setOpen(menu, toggle, false), HOVER_CLOSE_MS);
      });
    }

    // Keyboard: opening the menu on focus lets Tab reveal the tab links, and
    // blurring out of the whole component closes it.
    on(menu, 'focusin', () => {
      clearTimers();
      open();
    });
    on(menu, 'focusout', (e) => {
      if (!menu.contains(e.relatedTarget)) setOpen(menu, toggle, false);
    });

    // Escape closes and returns focus to the toggle.
    on(menu, 'keydown', (e) => {
      if (e.key === 'Escape') {
        setOpen(menu, toggle, false);
        toggle.focus();
      }
    });

    // Clicking a tab link closes the menu so it doesn't feel stuck mid-nav.
    on(menu, 'click', (e) => {
      if (e.target.closest('.ap-account-menu__item')) setOpen(menu, toggle, false);
    });
  });

  // Outside click closes any open account menu.
  on(document, 'click', (e) => {
    if (e.target.closest('[data-component="account-menu"]')) return;
    qsa('[data-component="account-menu"].is-open').forEach((menu) => {
      setOpen(menu, menu.querySelector('.ap-account-menu__toggle'), false);
    });
  });
}
